export default __webpack_public_path__ + "static/media/21.d8291976.png";